import { Link } from "react-router-dom";

const stats = [
  { value: "6000+", label: "影视资源" },
  { value: "50万+", label: "日均浏览" },
  { value: "10+", label: "内容分类" },
  { value: "4K", label: "高清画质示意" },
];

export default function IntroSection() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-16 bg-background-100/50">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
        <div>
          <span className="inline-flex items-center gap-2 text-accent-400 bg-accent-500/10 px-3 py-1 rounded-full text-xs md:text-sm">
            <i className="ri-leaf-line"></i>
            关于嫩草视频
          </span>
          <h2 className="mt-4 text-2xl md:text-4xl font-heading text-foreground-950 leading-tight">
            一站式发现优质影视内容
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            嫩草视频致力于为用户提供丰富多样的影视视频内容，覆盖最新电影、热门电视剧与精彩短片。
            我们通过清晰的分类导航、多维度的筛选条件与贴心的内容推荐，帮助你快速了解每一部作品的
            类型、主演与剧情简介，让观影决策变得轻松而高效。
          </p>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            无论你是追逐院线大片的影迷，还是追更热播剧集的剧粉，都能在嫩草视频找到属于你的那份精彩。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-2 h-11 px-6 rounded-md bg-secondary-500 text-background-50 text-sm font-medium hover:bg-secondary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            了解更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-4 md:gap-5">
          {stats.map((item) => (
            <div
              key={item.label}
              className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6"
            >
              <div className="text-2xl md:text-3xl font-heading text-primary-500">{item.value}</div>
              <div className="mt-2 text-xs md:text-sm text-foreground-600">{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}